import * as React from "react";
import { useSearchParams } from "react-router";

export type ThemeName = "lila" | "blue" | "refined";

export interface Theme {
  name: ThemeName;
  primary: string;
  primaryDeep: string;
  accent: string;
  accentSoft: string;
  ink: string;
  onDark: string;
  onDarkMuted: string;
  pageBg: string;
  pageGradient: string;
  cardBg: string;
  cardBorder: string;
  inputBg: string;
}

export const lilaTheme: Theme = {
  name: "lila",
  primary: "#4d2051",
  primaryDeep: "#2d142b",
  accent: "#f7a823",
  accentSoft: "rgba(247,168,35,0.18)",
  ink: "#2d142b",
  onDark: "#F2EAF4",
  onDarkMuted: "#B4AFB7",
  pageBg: "#361936",
  pageGradient:
    "radial-gradient(120% 120% at 85% 15%, #4F266B 0%, #3f1f57 28%, #361936 62%, #361936 100%)",
  cardBg: "#fbf9fc",
  cardBorder: "#E3E0E7",
  inputBg: "#ffffff",
};

export const blueTheme: Theme = {
  name: "blue",
  primary: "#0b2645",
  primaryDeep: "#07182d",
  accent: "#f7a823",
  accentSoft: "rgba(247,168,35,0.20)",
  ink: "#0a1a2e",
  onDark: "#E6EEF8",
  onDarkMuted: "#9DB1C8",
  pageBg: "#0b2645",
  pageGradient:
    "radial-gradient(120% 120% at 85% 15%, #14365e 0%, #0f2c4f 28%, #0b2645 62%, #07182d 100%)",
  cardBg: "#f6f9fd",
  cardBorder: "#D6E1EE",
  inputBg: "#ffffff",
};

export function useTheme(): Theme {
  const [searchParams] = useSearchParams();
  const themeParam = searchParams.get("theme");
  return themeParam === "blue" ? blueTheme : lilaTheme;
}

export function themeVars(theme: Theme): React.CSSProperties {
  return {
    ["--sm-primary" as any]: theme.primary,
    ["--sm-primary-deep" as any]: theme.primaryDeep,
    ["--sm-accent" as any]: theme.accent,
    ["--sm-accent-soft" as any]: theme.accentSoft,
    ["--sm-ink" as any]: theme.ink,
    ["--sm-on-dark" as any]: theme.onDark,
    ["--sm-on-dark-muted" as any]: theme.onDarkMuted,
    ["--sm-page-bg" as any]: theme.pageBg,
    ["--sm-page-gradient" as any]: theme.pageGradient,
    ["--sm-card-bg" as any]: theme.cardBg,
    ["--sm-card-border" as any]: theme.cardBorder,
    ["--sm-input-bg" as any]: theme.inputBg,
  };
}

export const FONT_BODY =
  "'Barlow', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif";
export const FONT_ACCENT =
  "'Playfair Display', Georgia, 'Times New Roman', serif";
